import {createContext} from "react";

type LayoutContextType = {
    mobileOpened: boolean;
    toggleMobile: () => void;
    desktopOpened: boolean;
    toggleDesktop: () => void;

    /**
     * If is subpage, layout will be displayed without navbar.
     * But we'll get back button.
     * @author Kacper Faber
     * @since 0.1.8
     */
    isSubPage: boolean;

    /**
     * Set subPage state.
     * @author Kacper Faber
     * @since 0.1.8
     * @param boo
     */
    setIsSubPage: (boo: boolean) => void;
}

/**
 * Throws not implemented error.
 * To use in defaults.
 * @author Kacper Faber
 * @since 0.1.1
 */
const notImplemented = () => {
    throw new Error("Not Implemented");
}

/**
 * Default implementation
 * @author Kacper Faber
 * @since 0.1.1
 */
const defaults: LayoutContextType = {
    mobileOpened: false,
    desktopOpened: false,
    isSubPage: false,
    toggleDesktop: notImplemented,
    toggleMobile: notImplemented,
    setIsSubPage: notImplemented
};

/**
 * Holds layout context.
 * To use in layout components like headers.
 * @author Kacper Faber
 * @since 0.1.1
 */
const layoutContext = createContext<LayoutContextType>(defaults);

export default layoutContext;